export default class TransportDetailsResponse {
    constructor(supportedLocales) {
        this.translations = [];
        this.id = null;
        this.multiplier = undefined;
        this.icon = undefined;
        this.availabilityInStatistics = undefined;
        this.maxKilometersPerMonth = undefined;
        this.maxKilometersPerDay = undefined;
        this.maxKilometersPerCurrentTransport = undefined;
        this.maxSpeedInKilometersPerHour = undefined;
        this.photo = undefined;
        this.coinsPerMeter = undefined;
        this.latitude = null;
        this.longitude = null;
        this.localizationTolerance = null;
        this.transportType = null;
        this.thresholdDistanceInKilometer = null;
        this.maximumRewards = null;
        this.steepness = null;
        this.type= null;
        this.pointsPerKilometer = 1;
        this.pointsPerActivity = null;
        this.teamMemberPointsPerActivity = null;
        supportedLocales.forEach((element) => {
            this.translations[element] = {
                name: '',
                phraseOfTraveledDistance: '',
                summaryText: '',
                summaryValueUnit: '',
                finalSummaryText: '',
                messageAfterSpeedLimitExceeded: '',
                messageKilometersPerCurrentTransportExceeded: '',
                messageKilometersPerMonthExceeded: '',
                messageKilometersPerDayExceeded: '',
                messageRadiusExceeded: '',
                messageNotValidStartPosition: '',
            };
        });
        this.mets = [];
        this.supportedLocales = supportedLocales;
    }

    static assign(from, to, locale) {
        if (from) {
            to.id = from.id;
            to.type = from.type;
            to.icon = from.icon;
            to.photo = from.photo;
            to.multiplier = from.multiplier;
            to.maxSpeedInKilometersPerHour = from.maxSpeedInKilometersPerHour;
            to.availabilityInStatistics = from.availabilityInStatistics;
            to.maxKilometersPerMonth = from.maxKilometersPerMonth;
            to.maxKilometersPerDay = from.maxKilometersPerDay;
            to.maxKilometersPerCurrentTransport = from.maxKilometersPerCurrentTransport;
            to.coinsPerMeter = from.coinsPerMeter;
            to.longitude = from.longitude;
            to.latitude = from.latitude;
            to.mets = from.mets;
            to.transportToMoneyRatio = from.transportToMoneyRatio;
            to.localizationTolerance = from.localizationTolerance;
            to.thresholdDistanceInKilometer = from.thresholdDistanceInKilometer;
            to.maximumRewards = from.maximumRewards;
            to.transportType = from.transportType;
            if (from?.transportType) {
                to.transportType.name = from.transportType?.translations[locale]?.name;
            }
            to.steepness = from.steepness;
            to.pointsPerKilometer = from.pointsPerKilometer;
            to.pointsPerActivity = from.pointsPerActivity;
            to.teamMemberPointsPerActivity = from.teamMemberPointsPerActivity;
            to.supportedLocales?.forEach((element) => {
                to.translations[element] = {
                    name: from.translations[element]?.name,
                    summaryValueUnit: from.translations[element]?.summaryValueUnit,
                    phraseOfTraveledDistance: from.translations[element]?.phraseOfTraveledDistance,
                    summaryText: from.translations[element]?.summaryText,
                    finalSummaryText: from.translations[element]?.finalSummaryText,
                    messageAfterSpeedLimitExceeded: from.translations[element]?.messageAfterSpeedLimitExceeded,
                    messageKilometersPerCurrentTransportExceeded: from.translations[element]?.messageKilometersPerCurrentTransportExceeded,
                    messageKilometersPerMonthExceeded: from.translations[element]?.messageKilometersPerMonthExceeded,
                    messageKilometersPerDayExceeded: from.translations[element]?.messageKilometersPerDayExceeded,
                    messageRadiusExceeded: from.translations[element]?.messageRadiusExceeded,
                    messageNotValidStartPosition: from.translations[element]?.messageNotValidStartPosition,
                };
            });
            if(to.transportToMoneyRatio){
                to.transportToMoneyRatio.forEach((c)=>{                   
                    if (c.dateFrom) {
                        c.dateFrom = new Date(c.dateFrom);
                    }
                })
            }
        } else {
            to = new TransportDetailsResponse();
        }
    }

    static copy(to, from, locale) {
        //const to = new TransportDetailsResponse();
        TransportDetailsResponse.assign(from, to, locale);
        return to;
    }
}
